import * as React from 'react';

interface BlankBackgroundProps {
  width: number;
  height: number;
}

const BlankBackground: React.SFC<BlankBackgroundProps> = (props) => {
  const { width, height } = props;
  return (
    <svg width={width} height={height}>
      <rect x="0" y="0" width={width} height={height} fill="#fff" />
    </svg>
  );
};

export default BlankBackground;
